import React from 'react';

import styles from '../../../../styles/sass/components/ToolsContent.module.scss';

interface Props {
  children: any;
}

interface State {
  width: number;
}

export default class Content extends React.Component<Props, State> {
  render() {
    return (
      <div className={styles.toolContentWrapper}>{this.props.children}</div>
    );
  }
}
